import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import {createMuiTheme, MuiThemeProvider, withStyles} from '@material-ui/core/styles';
import {fetchAllContent} from '../../../actions/contentActions';
import {connect} from "react-redux";
import MUIDataTable from "mui-datatables";
import _ from 'lodash';
import history from "../../../history";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import {theme} from "../../Dashboard/theme"

const columns = [
  {
    name: "_id",
    label: "Id",
    options: {
      filter: false,
      sort: true,
      display: false
    },
  },
  {
    name: "name",
    label: "Name",
    options: {
      filter: true,
      sort: true,
      display: true
    }
  },
  {
    name: "description",
    label: "Description",
    options: {
      filter: false,
      sort: false,
      display: true
    }
  },
  {
    name: "data",
    label: "Data",
    options: {
      filter: false,
      sort: false,
      display: true
    }
  },
  {
    name: "createdAt",
    label: "Created At",
    options: {
      filter: false,
      sort: true,
      display: false
    }
  },
  {
    name: "updatedAt",
    label: "Updated At",
    options: {
      filter: false,
      sort: true,
      display: true
    },
  },
];

const tableOptions = {
  filterType: "checkbox",
  onRowClick: (rowData, rowState) => {
    // console.log(rowData, rowState);
    history.push(`/dashboard/admin/contentManager/edit/${rowData[0]}`);
  },
  rowsPerPageOptions: [25, 50, 100],
  rowsPerPage: 100,
  responsive: "scrollMaxWidth",
  print: false,
  filter: false,
  download: false
};


const styles = theme => ({
  paper: {
    // maxWidth: 936,
    margin: 'auto',
    overflow: 'hidden',
  },
  contentWrapper: {
    margin: '40px 16px',
  },
});


class ContentTableContainer extends Component {

  getMuiTheme = () => createMuiTheme({
    ...theme,
    overrides: {
      MUIDataTableBodyCell: {
        root: {
          // backgroundColor: "#ff0000"
        },
        paper: {
          // backgroundColor: "primary"
        }
      },
      // MuiTableRow: {
      //   root: {
      //     verticalAlign: 'text-top'
      //   }
      // },
      // MUIDataTableFilter: {
      //   root: {
      //     backgroundColor: "#FAFAFA"
      //   }
      // }
      MUIDataTableHead: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "rgb(255, 255, 255)",
          borderBottom: "none"
        }
      },
      // MUIDataTableToolbar: {
      //   root: {
      //     backgroundColor: "#FFFFFF",
      //     color: "rgb(255, 255, 255)"
      //   }
      // },
      MUIDataTableToolbarSelect: {
        root: {
          backgroundColor: "#FFFFFF",
          // color: "rgb(255, 255, 255)"
        }
      },
    }
  });

  componentDidMount() {
    this.props.fetchAllContent();
  }

  render() {
    const {classes} = this.props;
    if (!_.isEmpty(this.props.contents)) {
      return (
        <Paper className={classes.paper}>
          {/*<ConnectionTable rows={this.props.contents}/>*/}
          <MuiThemeProvider theme={this.getMuiTheme(styles())}>
            <Grid container justify={"flex-end"}>
              <Grid item style={{padding: "16px"}}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => history.push(`/dashboard/admin/contentManager/new`)}
                >
                  Add new
                </Button>
              </Grid>
            </Grid>

            <MUIDataTable
              title="Content List"
              data={this.props.contents}
              columns={columns}
              options={tableOptions}
            />

          </MuiThemeProvider>
        </Paper>
      );
    } else {
      return null
    }
  }
}

ContentTableContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  if (state.content) {
    if (state.content.contents) {
      return {
        contents: state.content.contents ? Object.values(state.content.contents) : [],
        content: state.content.content
      }
    }
  }
  return state;
};

ContentTableContainer = withStyles(styles)(ContentTableContainer);
ContentTableContainer = connect(mapStateToProps, {fetchAllContent})(ContentTableContainer);


export default ContentTableContainer;

